import { LoadingManager } from "three";
import { Poly } from "../../engine/Poly";
export function modifyUrl(url) {
  const remapedUrl = Poly.assetUrls.remapedUrl(url);
  if (remapedUrl) {
    return remapedUrl;
  }
  const blobUrl = Poly.blobs.blobUrl(url);
  if (blobUrl) {
    return blobUrl;
  }
  return url;
}
export function createLoadingManager() {
  const loadingManager = new LoadingManager();
  loadingManager.setURLModifier(modifyUrl);
  return loadingManager;
}
export const LOADING_MANAGER = createLoadingManager();
const _CoreBaseLoader = class {
  constructor(_url, _node, blobOptions = {}) {
    this._url = _url;
    this._node = _node;
    this.blobOptions = blobOptions;
    this.loadingManager = LOADING_MANAGER;
  }
  static extension(url) {
    let ext = null;
    try {
      const _url = new URL(url);
      ext = _url.searchParams.get("ext");
    } catch (e) {
    }
    if (!ext) {
      const url_without_params = url.split("?")[0];
      const elements = url_without_params.split(".");
      ext = elements[elements.length - 1].toLowerCase();
    }
    return ext;
  }
  extension() {
    return _CoreBaseLoader.extension(this._url);
  }
  async _urlToLoad() {
    let fullUrl = this._url;
    if (this._node) {
      const assetsRoot = this._node.scene().assets.root();
      if (!fullUrl.startsWith("http")) {
        fullUrl = assetsRoot ? `${assetsRoot}/${fullUrl}` : fullUrl;
      }
      await Poly.blobs.fetchBlobForNode({
        fullUrl,
        node: this._node,
        multiAssetsForNode: this.blobOptions.multiAssetsForNode
      });
    }
    const blobUrl = Poly.blobs.blobUrl(fullUrl);
    return blobUrl || fullUrl;
  }
  static async _loadMultipleBlobGlobal(options) {
    const promises = [];
    for (let file of options.files) {
      const fullUrl = file.fullUrl;
      promises.push(Poly.blobs.fetchBlobGlobal(fullUrl));
    }
    const responses = await Promise.all(promises);
    if (options.node) {
      for (let response of responses) {
        if (response.error) {
          options.node.states.error.set(options.error);
        }
      }
    }
  }
};
export let CoreBaseLoader = _CoreBaseLoader;
CoreBaseLoader.loadingManager = LOADING_MANAGER;
